import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'kw-fill-layer-renderer',
  templateUrl: './fill-layer-renderer.component.html',
  styleUrls: ['./fill-layer-renderer.component.scss']
})
export class FillLayerRendererComponent implements OnInit,OnChanges {
  @Input() fillClass:string;
  @Input() fillColor:string;
  @Input() heightCls:string;
  
  constructor(private el:ElementRef<HTMLElement>) { }
  
  
  ngOnInit(): void {
  }



  ngOnChanges(changes: SimpleChanges): void {
    if(changes["fillClass"]){
      if(this.heightCls == undefined){
        let height:number = this.el.nativeElement.offsetHeight;
        this.heightCls = this.getHeightRange(height);
      }
    }
  } 

  getHeightRange(height:number){
    console.log(height)
    let range = "banner-small"
    if(height > 320 && height < 425){
      range = "banner-medium";
    }else if(height > 425) {
      range = "banner-large"
    }
    console.log(range);
    return range

  }



}
